import { cva } from "class-variance-authority";
import type { FC } from "react";

type Props = {
  variant: "card" | "tier";
};

const arcsVariants = cva("pointer-events-none absolute stroke-foreground", {
  variants: {
    variant: {
      card: "-top-[370px] -right-[370px] size-[692px] opacity-5",
      tier: "-top-[511px] -right-[472px] size-[914px]",
    },
  },
});

const OPACITY = {
  card: [0.4, 0.4, 0.4, 0.35, 0.3, 0.2, 0.15, 0.1, 0.05],
  tier: [
    0.035, 0.035, 0.0327, 0.0293, 0.0258, 0.0224, 0.0189, 0.0155, 0.012, 0.01,
    0.01, 0.01,
  ],
};

const Arcs: FC<Props> = ({ variant }) => {
  const opacities = OPACITY[variant];
  const half = 37 * opacities.length + 13;

  return (
    <svg
      data-slot="arcs"
      viewBox={`${-half} ${-half} ${half * 2} ${half * 2}`}
      fill="none"
      aria-hidden="true"
      className={arcsVariants({ variant })}
    >
      {opacities.map((opacity, index) => (
        <circle
          key={37 * (index + 1)}
          r={37 * (index + 1)}
          strokeWidth="26"
          strokeOpacity={opacity}
        />
      ))}
    </svg>
  );
};

export default Arcs;
